if (!customElements.get('kayf-purchase-bar')) {
  customElements.define('kayf-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById('MainProduct-' + this.dataset.section);
      if (!this.root) return;
      this.button = this.querySelector('[data-kayf-purchase]');
      this.chooseLink = this.querySelector('[data-kayf-choose]');
      this.selection = this.querySelector('[data-kayf-selection]');
      this.chosen = this.dataset.defaultVariant === 'true' || new URL(location.href).searchParams.has('variant');
      this.mobile = matchMedia('(max-width: 749px)');
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.nativeObserver = new MutationObserver(() => this.sync());
      this.intersection = new IntersectionObserver(entries => {
        this.nativeVisible = entries[0].isIntersecting;
        this.sync();
      }, {threshold:0});
      this.root.addEventListener('click', event => {
        this.bindControls();
        if (this.picker?.contains(event.target) && event.target.closest('input, label, select')) {
          this.chosen = true;
          this.sync();
        }
      }, options);
      this.root.addEventListener('change', event => {
        this.bindControls();
        if (this.picker?.contains(event.target)) this.chosen = true;
        this.sync();
      }, options);
      this.controlObserver = new MutationObserver(() => {
        const form = document.getElementById(this.dataset.form);
        if (form !== this.form || form?.querySelector('[name="add"]') !== this.nativeButton) {
          this.bindControls();
          this.sync();
        }
      });
      this.controlObserver.observe(this.root,{childList:true,subtree:true});
      this.onViewport = () => this.sync();
      this.mobile.addEventListener('change',this.onViewport);
      this.bindControls();
      this.sync();
    }
    bindControls() {
      const form = document.getElementById(this.dataset.form);
      const button = form?.querySelector('[name="add"]');
      this.picker = this.root.querySelector('variant-radios, variant-selects');
      this.quantity = this.root.querySelector('.quantity__input');
      if (!form || !button) return false;
      if (button !== this.nativeButton) {
        this.nativeObserver.disconnect();
        this.intersection.disconnect();
        this.form = form;
        this.nativeButton = button;
        this.nativeObserver.observe(button,{attributes:true,childList:true,subtree:true,characterData:true,attributeFilter:['disabled','aria-disabled']});
        this.intersection.observe(button);
      }
      return true;
    }
    sync() {
      if (!this.button || !this.bindControls()) return;
      const values = [...(this.picker?.querySelectorAll('input[type="radio"]:checked, select') || [])].map(e=>e.value);
      const quantity = this.quantity?.value || '1';
      this.selection.textContent = this.chosen ? (values.length?values.join(' / '):this.dataset.selection)+' · '+this.dataset.quantity+' '+quantity : this.dataset.choose;
      this.button.textContent = this.chosen ? (this.nativeButton.querySelector('span')?.textContent.trim() || this.nativeButton.textContent.trim()) : this.dataset.choose;
      this.chooseLink.hidden = this.chosen;
      this.button.hidden = !this.chosen;
      this.button.disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
      const visible = this.mobile.matches && !this.nativeVisible;
      this.hidden = !visible;
      document.body.classList.toggle('kayf-purchase-visible',visible);
      const preview = document.querySelector('iframe[src*="shopifycloud/preview-bar"]');
      document.documentElement.style.setProperty('--kayf-preview-offset',preview?'64px':'0px');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.nativeObserver?.disconnect();
      this.controlObserver?.disconnect();
      this.intersection?.disconnect();
      if (this.mobile && this.onViewport) this.mobile.removeEventListener('change',this.onViewport);
      document.body.classList.remove('kayf-purchase-visible');
    }
  });
}
